"use client"

import { FormattedMessage } from "react-intl"

import { Box, H2, P } from "@bullseye/components"

import { HomePage } from "../../../../src/components/HomePage"

function Page() {
  return (
    <HomePage
      title={
        <FormattedMessage
          id="home.hero.title.location"
          values={{ location: "New York" }}
        />
      }
      subtitle={
        <Box className="g-2">
          <FormattedMessage
            id="home.hero.subtitle.nysofa"
            values={{
              h2: (text) => <H2 className="text-white">{text}</H2>,
              s: (text) => <H2 className="text-white line-through">{text}</H2>,
              p: (text) => <P className="text-white">{text}</P>,
              strong: (text) => (
                <P bold className="text-white">
                  {text}
                </P>
              ),
            }}
          />
        </Box>
      }
    />
  )
}

export default Page
